import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-slider',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-slider works!</p> `,
  styles: ``,
})
export class CpSliderComponent {}
